import { useLatestRef } from "./use-latest-ref";
import { useEventListener } from "./use-event-listener";
const alphaRegex = /^[a-zA-Z]$/;

/**
 * Uses an action triggered by a hot key shortcut. The key pattern supports ctrl, shift, alt, and meta modifiers.
 * For example, a key pattern can be defined as `"ctrl+z"` or `"shift+ctrl+z"`.
 */
export function useHotKeys(config) {
  const configRef = useLatestRef(Array.isArray(config) ? config : [config]);
  const conf = configRef.current;
  useEventListener("keydown", event => {
    if (isValidEvent(event)) {
      conf.forEach(_ref => {
        let {
          keyPattern,
          onKeyPress
        } = _ref;
        if (matchesPattern(event, keyPattern)) {
          event.preventDefault();
          onKeyPress?.();
        }
      });
    }
  }, window, true);
}
function isValidEvent(event) {
  const el = event.target;
  return !event.repeat && !el.isContentEditable && el.tagName !== "INPUT" && el.tagName !== "SELECT" && el.tagName !== "TEXTAREA";
}
function matchesPattern(event, keyPattern) {
  const [key, ...modifiers] = keyPattern.split("+").reverse();
  return event.key.toLowerCase() === key.toLowerCase() && (!alphaRegex.test(event.key) || matchesModifiers(event, modifiers));
}
function matchesModifiers(event, modifiers) {
  return modifiers.includes("ctrl") === event.ctrlKey && modifiers.includes("shift") === event.shiftKey && modifiers.includes("alt") === event.altKey && modifiers.includes("meta") === event.metaKey;
}